module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "P_Heading_1",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_c('span', [_vm._v("Oops, Here I Go Again….")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("ELLERY LOOKED")]), _vm._v(" at the kid sitting on the other side of his desk and then at his tearful mother and wished his people skills were more on point.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Look, Ty, I know this wasn’t fair.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Dammit, there were sixty other kids at that party with X on them!” Ty Townsend burst out, and Ellery resisted the temptation to rub at his temples.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I know.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“And they were all white kids, and I was the only brown boy in the crowd!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I know, Ty.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Then what in the hell am I doing here?” he shouted, and Ellery’s temper broke.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“The fact that you are here is not my fault! The fact that you’re not letting me defend you "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("is")]), _vm._v("!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ty sat down abruptly. “What am I supposed to do?” he asked, wounded and angry and thoroughly confused, and not for the first time in the last weeks, Ellery wished for Jackson.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Jackson had a way with people. He probably could have had Ty eating out of his hand and a way to get Ty out of the charge of possession with intent to sell before Ty had even had to pay for his first consult.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But Jackson wasn’t here, and Ty’s mother had put a lot of money into getting Ty a lawyer who would not plead her barely eighteen-year-old son right into prison, and Ellery needed to pony up.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“If I’m convicted, I can’t go to school at the end of this week,” Ty said. “I’ll lose my scholarship. I’ll lose everything!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And part of Ellery wanted to say, “Well, you shouldn’t have grabbed the damned drugs as a party favor, then.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But the other part of him recognized the absolute unfairness of Ty’s arrest when he had not been the one who’d brought the X and he certainly hadn’t been the one to sell it—or use it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They’d get to that if and only if they could save this kid’s future first.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Look,” Ellery said, making sure Ty’s eyes were locked on his. “I can’t make promises because some of this is out of my control. But I will tell you this. We will talk to the police involved, we will talk to the other kids at the party, and I’ve got some tricks up my sleeve. I can’t guarantee that this will disappear, and I can’t guarantee that you won’t lose your scholarship, but I will do my damnedest to make sure you don’t see jail time. But I need some things from you first.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ty looked like he was going to get angry again, but his mother—a comfortable woman wearing what looked to be her Sunday-best dress in muted shades of gold and brown—put her hand on his arm and gave him a pleading glance.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Tyson, please,” she said softly. “I… I can’t have you in jail.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ty grimaced and nodded. “Okay, Mama.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("A mama’s boy. Ellery was one himself, and he approved of the breed in general.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“So,” Ellery said with a deep breath, “I need to know who gave you the drugs.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ty looked at his mother and then sighed. “Look, this could be really bad if it gets out who told you.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Was it a secret?” Ellery asked. “Your statement here says all the students had them.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“They did! We walked into No Neck’s house—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“James Cosgrove?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“No Neck,” Ty confirmed, and then he frowned. “Man, something was going around text about him this morning. Nate was losing his mind, but I had my own shit to sort. Anyway, he shook everyone’s hand and told us that Ziggy would hook us up.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“And Ziggy would be Sergio Ivanov,” Ellery said, making the note there.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yeah. Ziggy’s this little squirrely guy—eyeballs always vibrating. He’s not in high school. He pretends he is, but I could swear he’s a couple years older. Anyway, I went to the kitchen for—” He looked at his mother. “—water.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You gathered around the keg with all the other high school students. Don’t bullshit me, Tyson. I can’t help you if "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("I ")]), _vm._v("get busted in one of your lies.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tyson’s broad, football player’s shoulders slumped, and he gave his mother that look that only teenagers could have. The one that said their world was over, and they would take it all back if they could.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“So, yeah. I gathered around the keg, and Ziggy came up. He was always getting super familiar with us when we weren’t, you know, loving him. But he came up and gave me this handclasp bullshit, and when he pulled back I had a dime bag with three pills in it.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ellery frowned and looked at his police report again. “Three pills?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yeah. And I was like, ‘No, man, I’m already training. I leave next week,’ and he smiles this really slimy smile and goes, ‘Just a little party favor, yeah?’ And I don’t want to piss him off or hurt his feelings or anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Why not?” Ellery asked, curious.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tyson shifted as he sat. “I… I just get this really bad vibe off Ziggy. Like, this one time last year, at a football game, one of the guys got this real bad break. It was sort of scary, right? And I look up into the stands to see if Jaden’s mom is up there, and I see Ziggy, and he’s got this look on his face. This really shitty look. Like it was worth the price of admission to watch Jaden’s leg snap backward like that. So I don’t like Ziggy, but I don’t piss him off either.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ellery nodded. “Fair enough,” he said thoughtfully. “So he hands you a bag with three pills in it, and you…?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I put it in my pocket and tell him it’s for later. And I’m planning to throw it away.” Tyson had a man’s body: broad shoulders, arms like cannons, and a notable absence of neck. He was one of the best offensive tackles in the state. But the look that crossed his face then was even younger than the teenaged one. This one was a child, full-on vulnerable, and it broke Ellery’s heart.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I swear, Mama,” he said softly. “I was going to throw them away.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ralene Townsend wiped her eyes with her palm. “I know, sweetheart. You’re a good boy. I’ve never doubted it.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tyson let out a shuddering breath. “So I put them in my pocket, and I swear to God, not ten minutes later, the door bursts open, and it’s the cops.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Now, you say you were the only ‘brown face’ there. Can I ask if your school is mostly white?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tyson tilted his head. “Uhm, no, actually. It’s a pretty good mix.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Did it bother you to be the only person of color at an all-white party?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“No.” He shrugged. “Sorry. Not the only time it’s happened. Black people deal with it, you know?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ellery nodded. “I, well, I guess I can’t really understand personally, but I understand that the world works that way sometimes. I was just wondering if this was a rare occurrence or a usual one.” Because while Ellery hadn’t had a chance to put Henry on the case, he "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("had ")]), _vm._v("asked to see the files of the other kids arrested at that party and had been told that Tyson was the only one.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tyson frowned. “You know, now that you mention it, most of the parties I’ve gone to as a football player are pretty, you know, rainbow. ’Cause the team is pretty rainbow, and the school is all the colors, so it’s not so much me against the world.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“So, this was a situation that only happened at No Neck’s house?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tyson nodded slowly, and Ellery could see the wheels turning. “His family is pretty white. His grandparents were Russian, I guess, but we don’t really talk about it. Do you think I was set up?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I can’t say for sure, but we have lots of inconsistencies to look at when our PI gets here.” Jackson had texted when he and Henry had arrived at the PD’s office building; they should get there any minute. Ellery looked at the police report again, and then at Tyson. “Tyson, there are some differences between your police report and your story. Now, I’m going to ask you about them, and I don’t want you to get upset. I just want you to know this is me, looking for the truth. I’m not taking this document at face value, that’s why I’m asking.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tyson blinked slowly at him, and in spite of his size, Ellery could sense the intelligence that had made him an outstanding student athlete.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yessir,” he said. “What’s different?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Three pills. You said the little stapled baggie only had three pills in it.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ty nodded. “Yeah. I remember showing it to Nate Klein, and he showed me his own. He’s got his own scholarship and we were like, ‘Yeah, right,’ before we both shoved them in our pockets.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Three,” Ellery repeated grimly, circling the passage on the report that said "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("three dozen")]), _vm._v("."), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }), _vm._v("“What did they look like?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Pink, with a little butterfly on them. Same as Nate’s,” Tyson told him, looking confused. “What else?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Okay, you said the party was mostly white. Were these kids clean-cut white or grungy white?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Honors-student white.” Ty grimaced. “I remember thinking I didn’t know No Neck knew that many honors students.” He gave an abashed look. “No Neck’s not the smartest kid on the team, you know? Like, some of us got scholarships to out-of-state schools, but No Neck got a scholarship to the local junior college.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ellery grunted. “Okay. So I’m going to go out on a limb here and say that when the police report says ‘suspicious characters,’ they want me to think—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“There were a lot of Black people at the party?” Tyson said incredulously.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Or just a lot of shady people in general,” Ellery muttered. “That’s their reason for knocking on the door. Now, were you in easy visual of the door?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tyson suddenly got where this was going. “No, sir. I was in the hall.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Did they search anyone else?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“No, sir, they came straight to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ellery let out a sigh. “Did anyone remark on it?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Well, yeah. Nate was all up in their face until someone shoved him down and drew their weapon. He tried to tell them the drugs weren’t mine, but they shouted, ‘Whose were they?’ and Nate looked around and….” Tyson bit his lip. “Ziggy was gone.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ellery rubbed his temples and wished for Jackson. Jackson would have vetted this folder first, and then they could have discussed it, and then, oh God, he wouldn’t be the only one thinking that this setup was bad. So very, very bad.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Okay. Tyson, I need to talk to my associates. Don’t worry. We’re still taking your case. But—and I know you’re not supposed to leave town—but do you and your mother have a place to stay? One that your friends at school might not have visited or know about?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“His sister lives in Fair Oaks,” Ralene said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“That’s exactly what I’m talking about,” Ellery said, relief washing over him. “Do you have any pets or anything to care for?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“My dog, Captain,” Tyson said. “He’s a pit bull/shepherd mix. A rescue.” His square-jawed face went sloppy with adoration. “He’s super cute and so sweet.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Okay, then, I would like to talk to you both tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I don’t have money for—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Don’t worry about the hourly,” Ellery said. “Show us last year’s income tax, and I’ll have Jade come up with a reasonable fee. I just want your family and your dog to be someplace else while this is going on.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“But we take public transportation!” Ralene said. “We can’t take that dog on the train!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ellery pursed his lips. “Give me five minutes,” he said politely. “I’ll be right back.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He stood and left them in the office looking out the peaceful window, which featured a view of some of the spectacularly large leafy trees Sacramento was known for. The entire office, actually, from the windows looking out onto the trees in the yard next door to the wall with Ellery’s degrees on it, which was painted the color of a stormy blue-green ocean, was designed to make people feel serene and invigorated.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They could come here and take charge of their lives, with Ellery’s help.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But first Ellery had to take charge of his very late and very wayward boyfriend.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The nest of rooms in the refurbished Victorian house were part of a bigger office complex. As far as Ellery knew, they shared space with a headhunting firm next door and an adoption agency downstairs, which to his mind sort of added to the normalcy of a defense attorney. Everyday people could end up in extraordinary circumstances.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He and Jackson had decorated the suite with strong, happy colors—the teal gray in his office, the soothing browns and tans in the vacant office, and Galen had a strong combination of brown and burgundy.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And fortunately his door was open so Ellery didn’t feel bad about bothering his new partner.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Galen Henderson had been a stunningly handsome man before his motorcycle accident. His narrow, appealing face with its patrician features and bold nose was probably the toast of Miami. He wore his hair longer now, and kept a neatly trimmed goatee to help hide the scar that marred his temple and his cheek, but his brown eyes and sharp, sardonic gaze were still incredibly magnetic.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("His Southern roots and Ellery’s no-bullshit Yankee pragmatism were probably the things that would get the firm—now officially Cramer & Henderson, with Henry and Jackson listed as PIs in smaller script beneath their names—off the ground and through their first year.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Of course it helped that Henderson was so excited about practicing law again following his hiatus after his accident that he was willing to follow Ellery’s lead. Ellery had the feeling this man didn’t let much else guide him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What’s up?” Galen asked as Ellery poked his head in the door.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Have you heard from Henry?” Ellery chewed his lower lip.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Uhm… no.” Galen frowned. “Wasn’t he supposed to pick Jackson up and visit the PD’s?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ellery grimaced. “Yeah. They left over an hour ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Galen’s very expressive eyebrows “expressed.” “Oh dear.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I told him to do one thing,” Ellery said, fighting panic.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It could just be traffic,” Galen soothed. “Here, let me text Henry. He’s—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Less likely to ignore your call,” Ellery finished darkly.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Galen nodded, completely on board with that.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I need to go grab AJ for an errand. Tell me what Henry says.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Without waiting for an answer, Ellery strode to the empty conference room. He’d had Jade decorate this place, making it professional and comfortable at once. The chairs were roomy and supportive—and pretty, with sturdy wooden frames and fabric cushions—and the massive oval-shaped table in the center was heavy oak. At one end, with his laptop plugged into an outlet, sat a young man with long and tiny spirals of sunset-colored hair, and a pale brown face with pinpoints of dark brown freckles. He had a delicate chin and soulful eyes, and so much eagerness to help, Ellery always felt bad for asking him for anything extra.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But that didn’t mean he didn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Hey, Mr. Cramer.” He smiled excitedly, and Ellery wondered why Ellery was always “Mr. Cramer,” but Jackson was either “Jackson” to his family or “Rivers” to the people who really wished he just fucking wouldn’t do whatever it was he did to piss them off.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Hey, AJ. Look, I’ve got a favor. Are you game?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("AJ closed his laptop screen and nodded. “Yeah, sure. What do you need?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ellery outlined AJ’s job as chauffer and then winced. “Wait, what car are you driving? Because there is a dog invo—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“A dog? What kind? I love dogs!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’m just wondering if there’s enough room in your car,” he said, hiding a smile. AJ drove a battered “student-mobile” that had started out as a loaner Jackson bought for the kids coming out of jail who needed a fresh start. Jackson housed them in his half of the duplex he’d been living in when he and Ellery had first met, and Jade and her boyfriend helped Jackson keep an eye on them from the other half of the duplex. The idea was they got free rent as long as they could prove they were trying to get jobs or get into school or do something productive with their lives. The first group of young men had moved out in early June—AJ’s boyfriend among them—and the next group were mechanically inclined. Jackson got them their own loaner-mobile, and told them it was theirs to use as long as they fixed it up.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("AJ’s car didn’t have the benefit of someone who knew cars—although Mike tinkered with it once in a while—so it was a primer-spotted, shoestring, run-on-a-dime sort of vehicle, and Ellery wasn’t sure how well it would reflect on the firm.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Hold on a second,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Then he took his courage in both hands and went to talk to Jade.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Jade Cameron stood maybe five feet, four inches in her stocking feet, and her curves would send a race car on a spin. An African American goddess with a gimlet glare and a penchant for magenta both in her clothes and hair, she was one of the few people who had been there to take care of Jackson when the rest of the world had bailed.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ellery was Jackson’s person now, but before that happened, he’d had to get Jade’s seal of approval. He was pretty sure the only reason she’d turned over the reins was that Jade was quite simply exhausted by the job.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Uhm, Jade…,” he began as he approached her at the built-in secretary’s counter that separated the waiting room from the offices.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What do you need?” she asked, looking up from her computer with a frown line already between her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“The Townsends need a ride to their house and then across town.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Jade’s eyes widened. “We’re doing that now?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“There is something "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("very ")]), _vm._v("wrong with that police report,” Ellery growled, looking out into the waiting room and relieved to find it empty. “I don’t trust them to be safe in their house, especially not if Ty gives me the names of the other people at the party where he was busted. AJ can give them a ride, but….”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She was already digging through her purse for her keys. “Isn’t Jackson supposed to be coming in? I thought we were all doing lunch.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yeah. I expected him and Henry back about fifteen minutes ago. Think there was traffic? Maybe they stopped for lunch. Or coffee. Or….” Ellery wasn’t aware that he was rubbing his chest until Jade looked from his hand to his eyes and then back again.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yeah,” she said unhappily. “Maybe we should—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("At that point Ellery’s phone buzzed, and he pulled it out of his pocket.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And tried not to hyperventilate.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Don’t look at the news—we’re fine.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What?” she asked, taking in his expression. “What’s wrong?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Do you have a local news channel on your computer?” he asked, and his healthy breakfast made unhealthy noises as she pulled up a news site. They both read the scrolling banner across the top together.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-Center"
  }, [_c('span', [_vm._v("Shots Fired at Public Defender’s Headquarters. Police Have Suspect Barricaded in Stairwell.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Oh shit,” Ellery said, his heart pulsing in his throat.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Are we fucking serious here?” Jade asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Which was exactly what Ellery texted Jackson.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Are we fucking serious here?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Jackson returned, "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("I told you not to look!")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Where are you?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Hiding with Jenny Probst behind the giant copier in the supply closet.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("You do that a lot")]), _vm._v(","), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }), _vm._v("Ellery texted, and he could almost hear Jackson’s filthy laugh in return.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("It’s not as romantic as it sounds.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Is Henry with you? ")]), _vm._v("And Ellery wasn’t sure whether to hope yes or hope no.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Yes. He’s the guy who barricaded the door. Ellery, he was coming specifically for Jenny. Do you know why?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He thought about it. The Townsend case was hinky, but he already had that file because Jenny had dropped it off the day before. The guy currently barricaded on the stairwell wouldn’t know that, necessarily, but then it could also be the case file Jackson was supposed to pick up.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Or it could be something completely unconnected.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("I’d need to see the file she wanted you to get, but it could be something totally unrelated. You know that, right?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("His response was an emoji face with rolling eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("It’s possible")]), _vm._v(","), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }), _vm._v("he maintained stubbornly, partly because Jackson on the phone arguing was "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("not ")]), _vm._v("Jackson out in the thick of things taking unnecessary chances.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("She’s sort of hysterical right now. I may go get the case file just so I have something to do while I’m waiting.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Werewolf fucking Jesus,” Jade muttered, and Ellery stared at her.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“The fuck is that?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I don’t know. We saw a meme, we decided to make it a thing. But seriously, tell him no!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Please don’t")]), _vm._v(", Ellery typed, aware that his fingers were shaking.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("No response.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ellery pulled up Henry’s number and texted, "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Tell him to stay put")]), _vm._v("!")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("You tell him!")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Tell him I’ll kill him myself!")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Keep your shorts on. He’s back.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ellery stared at his phone, sweat trickling down his back, heart pounding like "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("he ")]), _vm._v("was the one in lockdown, waiting for an active shooter to pound through his door.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("When Jackson’s name flashed across his screen, he swore softly, “Werewolf fucking Jesus.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And smiled.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("I’m fine. Everything is fine. Got the file. I think cops took the shooter down with tasers. Give us an hour, we’ll be there.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("There was a pause while Ellery caught his breath, and the phone screen flashed again.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Want us to bring lunch?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ellery started to laugh softly and a little hysterically.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Don’t sweat it. Jade and I will walk down.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("His phone erupted then into a lot of texts saying mostly it was hot outside and not to bother and it was no big deal, but Jade was already running down the hallway to give her keys to AJ, and Ellery was heading for Galen’s office to brief him, and seriously.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ellery had given him one lousy thing to do.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("In Jackson’s words, "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("fuck ")]), _vm._v("that guy!")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("AJ DROPPED")]), _vm._v(" Ellery and Jade off about a block from the public defender’s building before driving away with Ralene and Ty Townsend in the back of Jade’s SUV, a little confused but very grateful.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Jade and Ellery joined the throng in front of the building, watching as two EMTs transported a guy handcuffed to his stretcher out of the building, two policemen on their heels.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Henry and Jackson followed—both of them looking casual and happy and 100 percent abso-fucking-lutely fine—escorted by a very familiar young detective. Sean Kryzynski had blond hair and blue eyes like Henry, but Sean’s narrower face, his more expressive eyes, his smaller build, marked him as another kind of creature entirely.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("When Ellery had first met Kryzynski, or K-Ski as Jackson and Jade had taken to calling him, he’d been super idealistic and super sure that Jackson had done something wrong in his past to deserve all of the bullshit the department threw at him. After a year of working together—sometimes willingly, sometimes not—Kryzynski had started to trust Jackson a little, and Jackson had stopped treating the guy like a raging yeast infection under his balls.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kryzynski had lost a little of his new-detective polish, but he’d gained some wisdom—and some lines around the eyes—over the past year.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ellery considered him a friend, and he was pretty sure Jackson did too.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You have no idea who this guy is?” Kryzynski said, for what sounded like the umpteenth time.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“He was the guy who shouted Jenny’s name and apparently fired his gun into the air. And I’m guessing he can run like the wind.” Jackson’s hand shifted as he walked with Kryzynski down the stairs, and Ellery was suddenly aware of the messenger bag at his hip.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Go, baby, go")]), _vm._v(","), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }), _vm._v("he thought silently, because oh yeah, they really needed to read that file.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kryzynski nodded. “You had to see the video replay. He seriously would have made it to her floor if you hadn’t barricaded the door.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“All Henry’s doing,” Jackson said mildly.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Jackson’s idea,” Henry said, sounding bored. “He was supposed to be taking it easy today.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kryzynski gave a real smile, one that reached his tired cop eyes. “First day back?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Jackson grimaced. “Wasn’t supposed to be.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Henry and Kryzynski both chortled.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Oh, it fucking figures,” Kryzynski said. He glanced up and spotted Ellery and Jade on the sidewalk at the same time Jackson and Henry did. “And guess who’s here to reinforce sick leave.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ellery gave a sigh and met Jackson’s apologetic gaze. “Wouldn’t dream of it,” he said. To his surprise, Jackson stepped forward and gave him a brief kiss on the temple before moving to his side.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I swear to God, Ellery, it wasn’t my—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Fault. Yeah, I get it.” A reluctant smile pushed at the corners of Ellery’s mouth. “I mean seriously, what are the odds?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kryzynski blew out a breath. “That this is related to something you two are doing? I’d take that bet. So what are you doing?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("At that point Henry’s stomach made a loud, obnoxious, unmistakable sound.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Jackson chuckled and Ellery said, “I think we’re going to lunch. You all want in?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Henry nodded and then grimaced. “Is it okay if I go get Galen? If we’re having a powwow, it feels rude to leave him alone at the office.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Text him first and make sure he’s not busy,” Jackson said. “But yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Tell him to grab the Townsend file from the top of my desk,” Ellery prompted. “I want Sean to see that one too.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Uh-oh,” Kryzynski said, eyes growing sober. “Am I going to like this?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I hope not,” Ellery said briskly. “’Cause if you do, you’re not the person I thought you were.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kryzynski groaned and rubbed the back of his neck. “You guys. You guys are like the cherry on the shit sundae, you know that?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Bad day already, K-Ski?” Jackson asked sympathetically.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kryzynski shook his head and glowered. “I don’t want to talk about it. Love life’s fine, thank you. Absolutely peachy.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Jackson and Ellery exchanged looks, but Jackson was the one who said it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“How’s the fireman?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Older than I am,” Kryzynski said sourly. “And he won’t let me forget it.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Someone called Kryzynski’s name, and he nodded to another detective down by the curb. “Look, guys, give me a restaurant not too far away and I’ll meet you there. Make it cheap and make it… franchisey, okay? If I have to eat kale today I might kill someone.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Understood,” Jackson said. “You go talk to whoever, we’ll go pick up Galen, and we’ll meet you at the Mongolian barbecue place a few blocks from here.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kryzynski’s eyes went to half-mast, and he damn near drooled. “That guy by the car is my partner—I may have to drop him off at Mercy San Juan so he can check in on our wild man in the stairwell.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“He get tasered pretty good?” Jackson asked, his eyes lighting up like this would not disappoint him at all.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Twice,” Kryzynski said with satisfaction. “I think he bit the tip of his tongue off and wet himself. Asshole. I feel no pity.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Meet in an hour, then,” Jackson told him, taking charge effortlessly like he did. He looked at Jade and Ellery. “Good news is, Henry brought Galen’s car. It’s got air-conditioning like a "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("boss")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ellery became aware of the sweat trickling down his back and the absolute airless thickness of the heat around them.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I may forgive you yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Jackson grinned. “Like I said, it was not my fault.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They turned and started walking for the parking lot, and Ellery let his hand brush Jackson’s as they went.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("That")]), _vm._v(",” he said grimly, “remains to be seen.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67cdd0c5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0008.vue
// module id = 78
// module chunks = 0